import React, { useState } from "react";
import { toast } from "@/lib/toast";
import api, { formatApiErrorDetail } from "@/lib/api";
import { ArrowClockwise, XCircle } from "@phosphor-icons/react";
import { fmtDate } from "@/lib/fmt";

// One-tap "Renew 30 days" / "Clear override" pair used in the bell, the
// carrier profile card and the Compliance audit table.
export const OverrideActions = ({ carrierId, onDone, size = "sm", testId = "override-action" }) => {
  const [busy, setBusy] = useState("");
  const run = async (kind, e) => {
    e?.stopPropagation?.();
    setBusy(kind);
    try {
      if (kind === "renew") {
        const { data } = await api.post(`/carriers/${carrierId}/compliance-override/renew`, { days: 30 });
        toast.success(`Override renewed — carrier stays dispatchable until ${fmtDate(data.compliance_override.until)}`);
      } else {
        await api.delete(`/carriers/${carrierId}/compliance-override`);
        toast.success("Override cleared — FMCSA block applies again");
      }
      onDone?.(kind);
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Action failed"); }
    finally { setBusy(""); }
  };
  const pad = size === "sm" ? "px-2.5 py-1 text-[11px]" : "px-3 py-1.5 text-xs";
  return (
    <span className="inline-flex items-center gap-1.5 flex-wrap" data-testid={`${testId}-wrap`}>
      <span role="button" tabIndex={0} onClick={(e) => run("renew", e)} onKeyDown={(e) => { if (e.key === "Enter") run("renew", e); }}
        data-testid={`${testId}-renew`} aria-disabled={!!busy}
        className={`inline-flex items-center gap-1 font-bold text-white bg-[#0A84FF] hover:bg-[#0058B0] rounded-full ${pad} cursor-pointer ${busy ? "opacity-60 pointer-events-none" : ""}`}>
        <ArrowClockwise size={12} weight="bold" /> {busy === "renew" ? "Renewing…" : "Renew 30 days"}
      </span>
      <span role="button" tabIndex={0} onClick={(e) => run("clear", e)} onKeyDown={(e) => { if (e.key === "Enter") run("clear", e); }}
        data-testid={`${testId}-clear`} aria-disabled={!!busy}
        className={`inline-flex items-center gap-1 font-bold text-red-700 border border-red-300 hover:bg-red-50 rounded-full ${pad} cursor-pointer ${busy ? "opacity-60 pointer-events-none" : ""}`}>
        <XCircle size={12} weight="bold" /> {busy === "clear" ? "Clearing…" : "Clear override"}
      </span>
    </span>
  );
};
